export enum SurveySourceType {
  UAV = 'UAV',
  SATELLITE = 'Satellite',
}
